/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Grid, List, ListItem, Typography } from '@mui/material';
import { getSplunkRecord } from '../../../../../store/reducers/splunk/splunkAction';


const SplunkInfo = ({ recordId }) => {
    const splunkInfo = useSelector(state => state.splunk.splunkInfo)
    const dispatch = useDispatch()
    useEffect(() => {
        console.log('recordId', recordId)
        dispatch(getSplunkRecord({ recordID: recordId }));
    }, [dispatch, recordId]);
    // Parse the result field safely
    const parseSplunkResult = (result) => {
        try {
            return result ? JSON.parse(result) : {};
        } catch (error) {
            console.error("Error parsing Splunk result:", error);
            return {};
        }
    };

    const parsedResult = splunkInfo?.result ? parseSplunkResult(splunkInfo.result) : {};

    return (
        <>
            <Typography variant="h3" align="center" color="success.light">
                Splunk Information
            </Typography>

            <Grid container direction="column" spacing={3}>
                {splunkInfo ? (
                    <Grid item>
                        <List>
                            {Object.entries({
                                ID: splunkInfo.recordID,
                                "Search Name": splunkInfo.search_name,
                                App: splunkInfo.app,
                                Owner: splunkInfo.owner,
                                SID: splunkInfo.sid,
                                "Results Link": splunkInfo.results_link,
                                "Source Type": parsedResult.sourcetype,
                                Host: parsedResult.host,
                                "Transaction ID": parsedResult.transId,
                                Process: parsedResult.process,
                                "Raw Data": parsedResult._raw,
                                "Conf STR": parsedResult._confstr,
                                "Event Type Color": parsedResult._eventtype_color,
                                "Index Time": parsedResult._indextime,
                                KV: parsedResult._kv,
                                Serial: parsedResult._serial,
                                Punct: parsedResult.punct,
                                Source: parsedResult.source,
                                "Splunk Server": parsedResult.splunk_server,
                                User: parsedResult.user,
                                "Updated By": splunkInfo.updatedBy,
                                "Created By": splunkInfo.createdBy,
                            }).map(([key, value]) => (
                                <ListItem key={key}>
                                    <Typography variant="h5" color="textSecondary">
                                        {key}:
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        sx={{ marginLeft: 2, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                                    >
                                        {value || "N/A"}
                                    </Typography>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                ) : (
                    <Grid item>
                        <Typography variant="h6" align="center" color="textSecondary">
                            No information available now, please try later.
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </>
    );
};
export default SplunkInfo;
